import actionTypes from "_constants/actionTypes";

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.PDF_CENTER_CLEAR:
            return {
                ...state,
                pdfCenter: undefined,
                pdfCenterError: undefined,
            };
        case actionTypes.PDF_CENTER_DATA:
            return {
                ...state,
                pdfCenter: action.payload,
                pdfCenterError: undefined,
            };
        case actionTypes.PDF_CENTER_ERROR:
            return {
                ...state,
                pdfCenter: undefined,
                pdfCenterError: action.payload,
            };
        case actionTypes.INFO_CENTER_CLEAR:
            return {
                ...state,
                infoCenterData: undefined,
                infoCenterError: undefined,
            };
        case actionTypes.INFO_CENTER_DATA:
            return {
                ...state,
                infoCenterData: action.payload,
                infoCenterError: undefined,
            };
        case actionTypes.INFO_CENTER_ERROR:
            return {
                ...state,
                infoCenterError: action.payload,
                infoCenterData: undefined,
            };
        case actionTypes.CLEAN_REGISTER_DATA:
            return {
                ...state,
                registerCenterData: undefined,
                registerCenterError: undefined,
            };
        case actionTypes.REGISTER_CENTER_DATA:
            return {
                ...state,
                registerCenterData: action.payload,
                registerCenterError: undefined,
            };
        case actionTypes.REGISTER_CENTER_ERROR:
            return {
                ...state,
                registerCenterError: action.payload,
                registerCenterData: undefined,
            };

        default:
            return state;
    }
};
